import type { RadioConfig } from '#types/config/components/vf/radio'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      shared: 'mt-0.5 p-0.75 h-4 w-4',
      variant: {
        base: {
          default: 'ring-brand-4',
          selected: 'ring-brand-4 c-brand-4'
        },
        inverse: {
          default: 'ring-brand-5',
          selected: 'ring-brand-5 c-brand-5'
        }
      }
    },
    label: {
      shared: 'body-3',
      variant: {
        base: {
          default: 'c-black'
        },
        inverse: {
          default: 'c-white'
        }
      }
    },
    wrapper: {
      shared: 'gap-x-2 items-start'
    }
  }
} satisfies RecursivePartial<RadioConfig>
